module.exports = __webpack_public_path__ + "static/media/newBooks.d4cada8f.png";